import { createFileRoute, redirect } from "@tanstack/react-router";

import { shellOpensFor } from "../authGate";
import { ProjectSettingsPage } from "../components/settings/ProjectSettingsPanel";

export const Route = createFileRoute("/projects/$projectKey")({
  beforeLoad: async ({ context }) => {
    if (!shellOpensFor(context.authGateState.status)) {
      throw redirect({ to: "/pair", replace: true });
    }
  },
  component: () => <ProjectSettingsPage projectKey={Route.useParams().projectKey} />,
});
